import { FC, useEffect, useState } from 'react';

import { useQuery, useQueryClient } from 'react-query';

import { useOperationalNote } from '@hooks_iqfu/common/useOperationalNote';

import styles from './RightColumnAdminSalesRepresentative.module.scss';

type Props = {
  targetId: string;
};

const RightColumnAdminSalesRepresentative: FC<Props> = ({ targetId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [adminSalesRepresentative, setAdminSalesRepresentative] = useState('');
  const { getCompanyOperationalNote, updateCompanyOperationalNote } = useOperationalNote();
  const queryClient = useQueryClient();

  const dispatchGetOperationalNote = () => {
    if (!targetId) return;
    return getCompanyOperationalNote({ companyId: targetId });
  };

  const dispatchCreateOperationalNote = async () => {
    if (!targetId || !operationalNote) return;
    return await updateCompanyOperationalNote({
      companyId: targetId,
      adminSalesRepresentative: adminSalesRepresentative,
    });
  };

  const { data: operationalNote } = useQuery(
    ['getOperationalNote', 'chat_property', targetId],
    () => dispatchGetOperationalNote(),
    {
      enabled: targetId !== 'undefined' && !!targetId,
      staleTime: 600,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    if (operationalNote?.admin_sales_representative || operationalNote?.admin_sales_representative === '') {
      setAdminSalesRepresentative(operationalNote.admin_sales_representative);
    }
  }, [operationalNote?.admin_sales_representative]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await dispatchCreateOperationalNote();
    setIsEditing(false);
    queryClient.invalidateQueries('getOperationalNote');
  };

  return (
    <form className={styles.right_column_container_item} onSubmit={handleSubmit}>
      <div className={styles.right_column_container_admin_sales_representative_area}>
        <p className={styles.right_column_container_admin_sales_representative_title}>加盟担当者</p>
        {!isEditing && (
          <a
            className={styles.right_column_container_admin_sales_representative_edit}
            onClick={() => {
              setIsEditing(true);
            }}
          >
            編集
          </a>
        )}
      </div>
      <div className={styles.right_column_container_admin_sales_representative_wrapper}>
        {isEditing ? (
          <input
            className={`${styles.right_column_container_admin_sales_representative} ${styles.isEditing}`}
            placeholder="加盟担当者を追加"
            value={adminSalesRepresentative}
            maxLength={50}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setAdminSalesRepresentative(event.target.value);
            }}
          />
        ) : (
          <p className={styles.right_column_container_admin_sales_representative}>{adminSalesRepresentative}</p>
        )}
      </div>
      {isEditing && (
        <div className={styles.right_column_container_buttons}>
          <button
            className={styles.cancel_button}
            onClick={() => {
              setIsEditing(false);
              if (operationalNote) setAdminSalesRepresentative(operationalNote?.admin_sales_representative ?? '');
            }}
          >
            キャンセル
          </button>
          <button type="submit" className={styles.submit_button}>
            保存
          </button>
        </div>
      )}
    </form>
  );
};

export default RightColumnAdminSalesRepresentative;
